import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import config from '../../config';

class Forbidden extends Component {
  componentWillMount() {
    document.getElementById('preloader-container').classList.remove('app-loading');
  }
  handleAction = (e) => {
    e.preventDefault();
    window.location.href = config.get('startURL');
  }
  render() {
    return (
      <Modal
        open
        basic
        size="small"
      >
        <Header icon="warning sign" content="Forbidden" />
        <Modal.Content>
          <h3>Oops! Looks like you do not have access.</h3>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={this.handleAction} inverted>
            <Icon name="home" /> Return home safely
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

Forbidden.contextTypes = {
  store: PropTypes.object,
};

export default Forbidden;



// WEBPACK FOOTER //
// ./src/containers/Forbidden.jsx